import { render, staticRenderFns } from "./f-email.vue?vue&type=template&id=4f730ab8&lang=pug&"
import script from "./f-email.vue?vue&type=script&lang=js&"
export * from "./f-email.vue?vue&type=script&lang=js&"
import style0 from "./f-email.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f730ab8')) {
      api.createRecord('4f730ab8', component.options)
    } else {
      api.reload('4f730ab8', component.options)
    }
    module.hot.accept("./f-email.vue?vue&type=template&id=4f730ab8&lang=pug&", function () {
      api.rerender('4f730ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-email.vue"
export default component.exports